import { render, staticRenderFns } from "./BoxSectionHeader.vue?vue&type=template&id=e2d17730&scoped=true&"
import script from "./BoxSectionHeader.vue?vue&type=script&lang=js&"
export * from "./BoxSectionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d17730",
  null
  
)

export default component.exports